import React from "react";
import { formatDateTime } from "../../utils/helper";
import { Column, FleetrifyCustomTable } from "../CustomTable/customTable";

export interface TableData {
  id: number;
  timestamp: string;
  user: string;
  module: string;
  "device type": string;
  event: string;
  details?: string;
  description: string;
  status: string;
}

const AuditLogTable = ({
  onRowClick,
  tableData,
  pageSize,
  totalPage,
  total,
  currentPage = 1,
  lastPage = 1,
  setCurrentPage,
}: {
  onRowClick: (param: TableData) => void;
  tableData: TableData[];
  pageSize?: number;
  totalPage?: number;
  total?: number;
  currentPage?: number;
  lastPage?: number;
  setCurrentPage?: (param: number) => void;
}) => {
  // handle row click
  const handleRowClick = (row: TableData) => {
    if (onRowClick) onRowClick(row);
  };

  const columns: Column[] = [
    { label: "Timestamp", key: "timestamp", sortable: true, render: (value) => formatDateTime(value) },
    { label: "User", key: "user", sortable: true },
    { label: "Module", key: "module", sortable: true },
    { label: "Device Type", key: "device type", sortable: true },
    { label: "Event", key: "event", sortable: true },
  ];

  return (
    <div>


      
      {tableData.length === 0 ? (
        <p className="text-center text-gray-500 mt-4">
          No data found under this category
        </p>
      ) : (
        <FleetrifyCustomTable
          onRowClick={handleRowClick}
          data={tableData}
          columns={columns}
          checkbox={false} 
          tooltipLeft
          pageSize={pageSize}
          currentPage={currentPage}
          lastPage={lastPage}
          total={total}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>



  );
};

export default AuditLogTable;
